/* SPDX-FileCopyrightText: 2014-present Kriasoft */
/* SPDX-License-Identifier: MIT */

import IconButton, { IconButtonProps } from "@mui/joy/IconButton";
import { useColorScheme } from "@mui/joy/styles";
import * as React from "react";

import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeIcon from "@mui/icons-material/LightMode";

const ColorSchemeToggle = React.forwardRef<
  HTMLButtonElement,
  IconButtonProps
>(function ColorSchemeToggle(props, ref) {
  const { onClick, sx, ...other } = props;
  const { mode, setMode } = useColorScheme();
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);
  if (!mounted) {
    return (
      <IconButton
        ref={ref}
        size="sm"
        variant="outlined"
        color="neutral"
        {...other}
        sx={sx}
        disabled
        aria-label="Toggle color scheme"
      />
    );
  }
  return (
    <IconButton
      ref={ref}
      data-screenshot="toggle-mode"
      size="sm"
      variant="outlined"
      color="neutral"
      {...other}
      aria-label={`Switch to ${mode === "light" ? "dark" : "light"} mode`}
      onClick={(event) => {
        if (mode === "light") {
          setMode("dark");
        } else {
          setMode("light");
        }
        onClick?.(event);
      }}
      sx={[
        mode === "dark"
          ? { "& > *:first-child": { display: "none" } }
          : { "& > *:first-child": { display: "initial" } },
        mode === "light"
          ? { "& > *:last-child": { display: "none" } }
          : { "& > *:last-child": { display: "initial" } },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <DarkModeRoundedIcon />
      <LightModeIcon />
    </IconButton>
  );
});

export default ColorSchemeToggle;
